export interface IPayinFilters {
  accessSignature?: string;
  accessTag?: string;
  accessUserId?: number;
  accessUserIP?: number;
  payinId?: number;
  walletId?: string;
  payinTag?: string;
  payinStatus?: string;
  userId?: number;
  userName?: string;
  userEmail?: string;
  beneficiaryUserId?: number;
  eventAlias?: string;
  walletTypeId?: number;
  paymentMethodId?: '2' | '20' | '27';
  createdDateFrom?: string;
  createdDateTo?: string;
  updatedDateFrom?: string;
  updatedDateTo?: string;
  pageNumber?: number;
  pageCount?: number;
  sortBy?: string;
  sortOrder?: string;
}

export enum PayinStatus {
  VALIDATED = 'VALIDATED',
  PENDING = 'PENDING',
  CANCELED = 'CANCELED',
}

export enum PayinType {
  'Credit Transfer',
  'Direct Debit',
}

export interface IPayinForm {
  label: number;
  walletId: number;
  beneficiaryId: string;
  amount: number;
  currency: string;
}

export interface IPayin {
  payinId: number;
  payinTag: string;
  payinStatus: PayinStatus;
  codeStatus: number;
  informationStatus: string;
  walletId: number;
  userId: number;
  cartId: number;
  walletEventName: string;
  walletAlias: string;
  userFirstname: string;
  userLastname: string;
  messageToUser: string;
  paymentMethodId: number;
  subtotalItems: string;
  subtotalServices: string;
  subtotalTax: string;
  amount: string;
  currency: string;
  distributorFee: string;
  createdDate: string;
  createdIp: string;
  paymentHtml: string;
  paymentLanguage: string;
  paymentPostUrl: string;
  paymentPostDataUrl: string;
  paymentAcceptedUrl: string;
  paymentWaitingUrl: string;
  paymentRefusedUrl: string;
  paymentCanceledUrl: string;
  paymentExceptionUrl: string;
  ibanFullname: string;
  ibanId: string;
  ibanBic: string;
  ibanTxEndToEndId: string;
  ibanTxId: string;
  refundAmount: string;
  totalRows: number;
  forwardUrl: string;
  payinDate: string;
  mandateId: number;
  creditorName: string;
  creditorAddressLine: string;
  creditorCountry: string;
  creditorIban: string;
  creditorBIC: string;
  virtualIbanId: number;
  virtualIbanReference: string;
  DbtrIBAN: string;
}
